import { FC } from 'react'
import { IconPaths, KTSVG } from '_metronic/helpers'

type IProps = {
  icone: IconPaths
  /** Classes extras; outro tamanho que não o do texto vem por `fs-*` (ex.: `fs-4`). */
  className?: string
}

/**
 * Ícone decorativo da tela, no padrão `svg-icon-em` do sistema: mede 1em e herda tamanho e cor
 * do texto. Sempre `aria-hidden`: o texto ao lado (ou o `aria-label` do botão) é quem dá o nome.
 */
export const Icone: FC<IProps> = ({ icone, className = '' }) => (
  <KTSVG path={icone} className={`svg-icon-em ${className}`} ariaHidden />
)
